import React from 'react';
import Attachment from "../../../model2/attachment/attachment";

type Props = {
    attachment: Attachment;
}

export default function AttachmentPill(props: Props) {
    return (
        <div className="ui5-pill-u gray s-22 w-150 min-w-150 m-r-5">
            <div className="flex-row-left-center txt-truncate">
                <div className="ui5-ico-13 i5-attachment m-r-5"></div>
                <div className="ui5-txt-less-important-small txt-truncate">
                    {props.attachment.name}
                </div>
            </div>
        </div>
    );
}
